import { text } from './text';

const palette = {
  50: '#fdffe7',
  100: '#f8fdc2',
  200: '#f1fb97',
  300: '#eaf969',
  400: '#e3f53f',
  500: '#eaff15',
  600: '#dceb08',
  700: '#cbd400',
  800: '#bbbc00',
  900: '#a09400',
};

export const chartreuse = {
  ...palette,
  light: palette[300],
  main: palette[600],
  dark: palette[800],
  darker: palette[900],
  contrastText: text.contrast,
};
